import { get, writable } from 'svelte/store';
import { user } from '../../app.store';
import { navigate } from '../../app.logic';
import moment from 'moment';
import { ActivityService } from '../../services/activity.service';
import { DossierService } from '../../services/dossier.service';
import { ReportsService } from '../../services/reports.service';
import { PortalUserService } from '../../services/portal-user.service';
import { showToast } from '../../utils/misc/toast-utils';
let filterInitialized = false;
export const loading = writable(false);
export const filter = writable({ criteria: {}, params: null, sorting: "" });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const dossier = writable(null);
export const stats = writable(null);
export const applyUserRevenue = writable(false);
export async function initList() {
    if (filterInitialized === false) {
        let now = moment().startOf("day").local().toDate();
        let dateFrom = moment(now).subtract(10, 'day').startOf("day").local().toDate();
        let dateTo = now;
        let criteria = { query: '', dateFrom: dateFrom, dateTo: dateTo };
        filter.set({ criteria: criteria, params: null, sorting: "" });
        filterInitialized = true;
    }
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    dossier.set(null);
    stats.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    dossier.set(null);
    loadSettings();
    if (oid == 0) {
        let now = moment().startOf("day").local().toDate();
        let year = now.getFullYear();
        let authUser = get(user);
        let _userResp = await PortalUserService.fetchPortalUser(authUser.oid);
        let _us = _userResp.payload;
        //console.log("new portal user: ");
        let act = { oid: 0, date: now, year: year, portalUserId: authUser.oid, hourlyLaborCost: _us.hourlyCost, title: '' };
        if (get(applyUserRevenue) == true) {
            act.hourlyRevenue = _us.hourlyRevenue;
        }
        record.set(act);
        dossier.set(null);
    }
    else {
        let _resp = await ActivityService.fetchActivity(oid);
        //console.log("fetched portal user: ", _resp);
        if (_resp.payload.dossierId != null) {
            let _dossierResp = await DossierService.fetchDossier(_resp.payload.dossierId);
            if (_dossierResp != null) {
                dossier.set(_dossierResp.payload);
            }
        }
        record.set(_resp.payload);
    }
}
function loadSettings() {
    let theUser = get(user);
    let _applyUserRevenue = theUser != null ? theUser.regionSettings.applyUserRevenue : false;
    applyUserRevenue.set(_applyUserRevenue === 1);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await ActivityService.getActivities(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
        loadStats();
    }
    finally {
        loading.set(false);
    }
}
async function loadStats() {
    let _filter = get(filter);
    let _resp = await ActivityService.getActivityStats(_filter);
    stats.set(_resp.payload);
}
export function onCreate() {
    // console.log("onCreate");
    navigate(`/activity/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/activity/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    let _resp = await ActivityService.saveActivity(_record);
    return _resp.payload;
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await ActivityService.deleteActivity(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export function onExport() {
    let _filter = get(filter);
    ReportsService.exportExcelActivities(_filter);
}
export function onGeneralExport() {
    let _filter = get(filter);
    ReportsService.exportExcelGeneral(_filter);
}
export async function bulkChangeInvoicingStatus(invoiced) {
    let _filter = get(filter);
    if (_filter == null)
        return;
    let status = invoiced ? 1 : 0;
    let _resp = await ActivityService.bulkChangeActivitiesInvoiceStatus(_filter, status);
    load();
    showToast("Stato di fatturazione modificato", 'is-success');
    return _resp;
}
